module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Chapter-Number",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "Chapter-Opening"
  }, [_c('span', {
    staticClass: "Chapter-Opening-Words _idGenCharOverride-1"
  }, [_vm._v("Writing and publishing a novel")]), _vm._v(" is not the work of a single person, and there are many who have contributed greatly to the completion of "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("Guarding Savage")]), _vm._v(". First, I want to thank Elizabeth Turnbull, my editor, for her countless suggestions and prods that "), _c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("always")]), _vm._v(" make the Peter Savage novels better. Also, a huge thank you to Betty and Wally at Light Messages Publishing for making these books possible. And a special thank you to my former publicist, Kylee Wooten, for all her hard work in promoting the Peter Savage novels as well as helping to guide me through the art and etiquette of social media marketing, as well as the many fabulous graphics she’s created. I’m sad to say “former” because Kylee has moved on to a new marketing position with a sports equipment startup. All the best wishes, Kylee.")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_vm._v("I want to express my gratitude and appreciation to the many advance copy reviewers, and a special thank you to Gary Stout and Gordon Gregory for your many good suggestions and constant encouragement.")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_c('span', {
    staticClass: "Italic _idGenCharOverride-2"
  }, [_vm._v("Guarding Savage")]), _vm._v(" has many nautical scenes that required knowledge of U.S. Naval terminology, especially the phrasing of orders onboard warships. For help with this topic, I turned to my good friend and Navy veteran, Bill Shank. Thank you, Bill, for patiently guiding me through this specific terminology, seemingly arcane to a landlubber like me.")]), _vm._v(" "), _c('p', {
    staticClass: "Body-Text"
  }, [_vm._v("Last, but far from least, my heartfelt appreciation to you, the readers of these novels. It is a joy to read your emails, and the occasions when I have an opportunity to meet Peter Savage fans are always special moments. Please know that I read all emails sent in through my web site, or contacts through Light Messages:")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("www.PeterSavageNovels.com")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_vm._v("dedlund@LightMessages.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618f3999","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/97816115330883.vue
// module id = 69
// module chunks = 0